import { InspectionCase, SubCases } from '@authority-labs/api-interfaces';
import { CertificateComponent } from '../sprinklers/certificate-sprinklers/certificate.component';

export class CertificateBase1001Component extends CertificateComponent {
  getInspectionCases(cases: SubCases[] = []): InspectionCase[] {
    return cases?.flatMap((c) => c.subCases);
  }
}
